import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Popover, QRCode, Table, Tooltip } from "antd";
import axios from "axios";
// import {
//   CustomerOrderInfo,
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../context";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ExpandAltOutlined,
  ScheduleOutlined,
  QrcodeOutlined,
  SyncOutlined,
} from "@ant-design/icons";
// import MerchantOrdersDetails from "./MerchantOrdersDetails";
// import MerchantLayout from "../../layout/MerchantLayout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  CustomerOrderInfo,
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import MerchantCreateCustomer from "./MerchantCreateCustomer";
// import MerchantCreateCustomer from "./MerchantCreateCustomer";
import LOGO from "./../../../../assets/tinyimg/logo.webp";
import MerchantExtendService from "./MerchantExtendService";
import MerchantCheckoutService from "./MerchantCheckoutService";

const MerchantForCheckout = ({
  merchantOrderSaveList,
  activeServiceList,
  rerun,
  loading,
  setLoading,
  refresh,
}) => {
  const [search, setSearch] = useState("");
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openExtendDrawer, setOpenExtendDrawer] = useState(false);
  const [openCheckoutDrawer, setOpenCheckoutDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction #",
      dataIndex: "transaction_id",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Started",
      // dataIndex: "started_date",
      render: (text, record) => (
        <p>
          {text.service_type === "one-time"
            ? "--:---:---"
            : moment(`${text.started_date.replace(" ", "T")}.000000Z`)
                .utc()
                .format("LT")}
        </p>
      ),
    },
    {
      title: "End",
      // dataIndex: "ended_date",
      render: (text, record) => (
        <p>
          {text.service_type === "duration"
            ? moment(`${text.ended_date.replace(" ", "T")}.000000Z`)
                .utc()
                .format("LT")
            : "--:---:---"}
        </p>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "service_category",
    //   render: (text, record) => <p>status</p>,
    // },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 150,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 150 }}>
          {text.service_type !== "one-time" && (
            <Tooltip title="Order QR" placement="bottom">
              <Popover
                overlayInnerStyle={{
                  padding: 0,
                }}
                content={
                  <QRCode
                    value={`${import.meta.env.VITE_API_SITE_URL}${
                      userData.data.id
                    }/${userData.data.merchant_uid}/${text.transaction_id}`}
                    bordered={false}
                    style={{
                      marginBottom: 16,
                    }}
                    icon={LOGO}
                    errorLevel="Q"
                  />
                }
              >
                <Button
                  type="dashed"
                  shape="circle"
                  //   onClick={() => {
                  //     setSelectedData(text);
                  //     // setOpenExtendDrawer(true);
                  //   }}
                  icon={<QrcodeOutlined />}
                  style={{ marginRight: 5 }}
                  size="small"
                />
              </Popover>
            </Tooltip>
          )}

          {text.service_type === "duration" && (
            <Tooltip title="Extend">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setOpenExtendDrawer(true);
                }}
                icon={<ExpandAltOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Tooltip>
          )}

          <Tooltip title="Checkout">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenCheckoutDrawer(true);
              }}
              icon={<ScheduleOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteCustomerService();
    }, 2000);
  };

  const handleDeleteCustomerService = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    // setLoadings(true);
    axios
      .post("user/merchant/delete-avail-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete service successfully.");
          setTimeout(() => {
            // setLoadings(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search-order"
              placeholder="Search transaction # or name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenDrawer(true)}
            style={{ marginRight: 5 }}
          >
            Add
          </Button>
          <Button type="default" icon={<SyncOutlined />} onClick={refresh}>
            Refresh
          </Button>
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantCreateCustomer
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          activeServiceList={activeServiceList}
        />
      )}

      {openExtendDrawer && (
        <MerchantExtendService
          open={openExtendDrawer}
          close={() => setOpenExtendDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          selectedData={selectedData}
        />
      )}

      {openCheckoutDrawer && (
        <MerchantCheckoutService
          open={openCheckoutDrawer}
          close={() => setOpenCheckoutDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerun()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Delete this transaction?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MerchantForCheckout;
